<script setup>
import {ref} from "vue";
import { useRouter } from 'vue-router'
import SNBPolicy from "../../../../../layouts/nav/SNBPolicy.vue";

const router = useRouter()

const selectedOption = ref({ label: '', value: '' });

const personalList = [
  { label:"[현행]2025년 05월 29일", value: "terms20250529" },
  { label:"이전 변경 이력 없음", value: "" },
];

const onSelectPersonal = (option) => {
  if (option.value === '') {
    return; // 빈 값이면 조기 종료
  }

  selectedOption.value = option
}

</script>

<template>
  <div class="container">
    <div class="inner">
      <div class="flex-wrap">
        <SNBPolicy class="snb" />
        <div class="content">
          <div class="lecture-wrap">
            <div class="sub-title">
              <h3>서비스 이용약관</h3>
            </div>
            <div class="content-title grid" style="justify-content: flex-end;">
              <KSASelect :options="personalList" class="select" @selectOption="onSelectPersonal" />
            </div>
            <!--v-if="selectedOption.value === 'terms20250529'"-->
            <div>
              제 1 장 &nbsp;&nbsp;&nbsp;총 칙<br/><br/><br/>

              제 1 조 (목적)<br/>
              이 약관은 한국디스플레이산업협회(이하"기관"이라 표기) 에서 제공하는 홈페이지의 정보 및 서비스의  이용조건 및 절차에 관한 사항을 규정함을 목적으로 합니다.<br/><br/><br/>

              제 2 조 (약관의 공지 및 준용)<br/>
              ① 이 약관의 내용은 서비스 화면에 게시하거나 기타의 방법으로 회원에게 공지함으로써 효력을 발생합니다.<br/>
              ② 기관은 이 약관을 변경할 수 있으며, 변경된 약관은 제1항과 같은 방법으로 공지함으로써 효력을 발생합니다.<br/><br/><br/>

              제 3 조 (약관 외 준칙)<br/>
              이 약관에 명시되지 않은 사항은 전기통신기본법, 전기통신사업법 및 기타 관련법령의 규정에 의합니다.<br/><br/><br/>
              제 4 조 (용어의 정의)<br/>
              이 약관에서 사용하는 용어의 정의는 다음과 같습니다.<br/>
              - 회원 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;: 기관과 서비스 이용계약을 체결한 자<br/>
              - 아이디(ID) : 회원 식별과 회원의 서비스 이용을 위하여 회원이 선정하고 기관이 승인하는 문자와 숫자 조합<br/>
              - 비밀번호 &nbsp;&nbsp;&nbsp;: 회원의 비밀 보호를 위해 회원 자신이 설정한 문자와 숫자의 조합<br/><br/><br/><br/>

              제 2 장 &nbsp;&nbsp;&nbsp;서비스 이용계약<br/><br/><br/>

              제 5 조 (이용계약의 성립)<br/>
              ① 아래 "위의 이용약관에 동의하십니까?" 라는 물음에 회원이 "동의합니다" 단추를 누르면 이 약관에 동의하는 것으로 간주됩니다.<br/>
              ② 이용계약은 회원의 이용신청에 대하여 기관이 승낙함으로써 성립합니다.<br/><br/><br/>

              제 6 조 (이용신청)<br/>
              이용신청은 온라인으로 가입신청서 양식에 내용을 기록하여 신청합니다.<br/><br/><br/>

              제 7 조 (이용신청의 승낙)<br/>
              ① 기관은 회원이 가입신청서의 필수기재 항목을 정확히 기재하여 이용신청을 하였을때 승낙합니다.<br/>
              ② 기관은 다음 각 호의 1에 해당하는 이용신청에 대하여는 승낙을 유보할 수 있습니다.<br/>
              1) 설비에 여유가 없는 경우<br/>
              2) 기술상 지장이 있는 경우<br/>
              3) 기타 기관이 필요하다고 인정되는 경우<br/>
              ③ 회사는 다음 각 호의 1에 해당하는 이용신청에 대하여는 이를 승낙하지 아니 할 수 있습니다.<br/>
              1) 이름이 실명이 아닌 경우<br/>
              2) 다른 사람의 명의를 사용하여 신청한 경우<br/>
              3) 이용신청시 필요내용을 허위로 기재하여 신청한 경우<br/>
              4) 사회의 안녕질서 또는 미풍양속을 저해할 목적으로 신청한 경우<br/>
              5) 기타 회사가 정한 이용신청요건이 미비되었을 때<br/><br/><br/>

              제 8 조 (계약사항의 변경)<br/>
              ① 회원은 이용신청시 기재한 사항이 변경되었을 경우에는 온라인수정을 해야 합니다.<br/>
              ② 이용신청시 기재한 사항이 변경되었을 경우에  수정하지 않아 발생하는 모든 결과에 대한 책임은 회원에게 있습니다.<br/><br/><br/><br/>

              제 3 장 &nbsp;&nbsp;&nbsp;서비스 이용<br/> <br/><br/>

              제 9 조 (기관의 의무)<br/>
              기관은 서비스 제공과 관련해서 알고 있는 회원의 신상정보를 본인의 승낙없이 제3자에게 누설, 배포하지 않습니다. 단, 전기통신기본법 등 법률의 규정에 의해 국가기관의 요구가 있는 경우, 범죄에 대한 수사상의 목적이 있거나 정보통신윤리위원회의 요청이 있는 경우, 또는 기타 관계법령에서 정한 절차에 따른 요청이 있는 경우에는 그러하지 않습니다. 개인정보보호정책은 웹사이트에 별도 표기 합니다. <br/><br/><br/>

              제 10 조 (회원 아이디(ID)와 비밀번호 관리에 대한 의무)<br/>
              ① 아이디(ID)와 비밀번호에 관한 모든 관리책임은 회원에게 있습니다. 회원에게 부여된 아이디(ID)와 비밀번호의 관리소홀, 부정사용에 의하여 발생하는 모든 결과에 대한 책임은 회원에게 있습니다.<br/>
              ② 자신의 아이디(ID)가 부정하게 사용된 경우 회원은 반드시 기관에 그 사실을 통보 해야 합니다.<br/><br/><br/>

              제 11 조 (서비스 전반에 관한 회원의 의무)<br/>
              ① 회원은 서비스를 이용할 때 다음 각 호의 행위를 하지 않아야 합니다.<br/>
              1) 다른 회원의 ID를 부정하게 사용하는 행위<br/>
              2) 서비스에서 얻은 정보를 기관의 사전승낙 없이 회원의 이용이외의 목적으로 복제하거나 이를 출판 및 방송 등에 사용하거나 제 3자에게 제공하는 행위<br/>
              3) 제3자의 저작권 등 기타 권리를 침해하는 행위<br/>
              4) 공공질서 및 미풍양속에 위반되는 내용의 정보, 문장, 도형 등을 타인에게 유포하는 행위<br/>
              5) 범죄와 결부된다고 객관적으로 판단되는 행위<br/>
              6) 기타 관계법령에 위배되는 행위<br/>
              ② 회원은 이 약관에서 규정하는 사항과 서비스 이용안내 또는 주의사항을 준수하여야 합니다.<br/>
              ③ 회원은 내용별로 기관이 서비스 공지사항에 게시하거나 별도로 공지한 이용제한 사항을 준수하여야 합니다.<br/>
              ④ 회원은 기관의 사전승낙 없이는 서비스를 이용하여 영업활동을 할 수 없으며, 영업활동의 결과와 회원이 약관에 위반한 영업활동을 이용하여 발생한 결과에 대하여 기관은 책임을 지지 않습니다.<br/><br/><br/>
              제 12조 (정보의 제공)<br/>
              기관은 회원에게 서비스 이용, 기관의 각종 행사, 기타 다양한 정보서비스를 전자우편이나 서신우편, 기타 방법으로 제공할 수 있습니다.<br/><br/><br/>

              제 13 조 (회원의 게시물)<br/>
              기관은 회원이 게시하거나 등록하는 서비스내의 내용물이 다음 각 호의 1에 해당한다고 판단되는 경우에 사전통지 없이 삭제할 수 있습니다.<br/>
              1) 다른 회원 또는 제3자를 비방하거나 중상모략으로 명예를 손상시키는 내용인 경우<br/>
              2) 공공질서 및 미풍양속에 위반되는 내용인 경우<br/>
              3) 범죄적 행위에 결부된다고 인정되는 내용인 경우<br/>
              4) 제 3 자의 저작권 등 기타 권리를 침해하는 내용인 경우<br/>
              5) 기관에서 규정한 게시기간을 초과한 경우<br/>
              6) 기타 관계법령에 위반된다고 판단되는 경우<br/><br/><br/>

              제 14 조 (게시물의 저작권)<br/>
              서비스에 게재된 자료에 대한 권리는 다음 각 호와 같습니다.<br/>
              1) 게시물에 대한 권리와 책임은 게시자에게 있으며 기관은 게시자의 동의 없이는 이를 영리적 목적으로 사용할 수 없습니다. 단, 비영리적인 경우는 그러하지 아니하며 또한 서비스내의 게재권을 갖습니다.<br/>
              2) 회원은 서비스를 이용하여 얻은 정보를 가공, 판매하는 행위 등 서비스에 게재된 자료를 상업적으로 사용할 수 없습니다.<br/><br/><br/>

              제 15 조 (서비스 이용시간)<br/>
              ① 서비스의 이용은 기관의 업무상 또는 기술상 특별한 지장이 없는 한 연중무휴 1일 24시간을 원칙으로 합니다. 다만 정기 점검 등의 필요로 기관이 정한 날이나 시간은 그러하지 않습니다.<br/>
              ② 기관은 서비스를 일정범위로 분할하여 각 범위별로 이용가능시간을 별도로 정할 수 있으며 이 경우 그 내용을 사전에 공지합니다.<br/><br/><br/>

              제 16 조 (서비스 제공의 중지)<br/>
              ① 회사는 다음 각 호에 해당하는 경우 서비스 제공을 중지할 수 있습니다.<br/>
              1) 서비스용 설비의 보수 등 공사로 인한 부득이한 경우<br/>
              2) 전기통신사업법에 규정된 기간통신사업자가 전기통신서비스를 중지했을 경우<br/>
              ② 국가비상사태, 정전, 서비스 설비의 장애 또는 서비스 이용의 폭주 등으로 정상적인 서비스 이용에 지장이 있는 때에는 서비스의 전부 또는 일부를 제한하거나 정지할 수 있습니다.<br/><br/><br/><br/>

              제 4 장 &nbsp;&nbsp;&nbsp;계약해지 및 이용제한<br/><br/><br/>

              제 17 조 (계약해지 및 이용제한)<br/>

              ① 회원이 이용계약을 해지하고자 하는 때에는 회원 본인이 온라인을 통해 기관에 해지신청을 하여야 합니다.<br/>
              ② 기관은 회원이 다음 각 호의 1에 해당하는 행위를 하였을 경우 사전통지 없이 이용계약을 해지하거나 또는 기간을 정하여 서비스 이용을 중지할 수 있습니다.<br/>
              1) 타인의 서비스 ID 및 비밀번호를 도용한 경우<br/>
              2) 서비스 운영을 고의로 방해한 경우<br/>
              3) 가입한 이름이 실명이 아닌 경우<br/>
              4) 같은 사용자가 다른 ID로 이중등록을 한 경우<br/>
              5) 공공질서 및 미풍양속에 저해되는 내용을 고의로 유포시킨 경우<br/>
              6) 회원이 국익 또는 사회적 공익을 저해할 목적으로 서비스 이용을 계획 또는 실행하는 경우<br/>
              7) 타인의 명예를 손상시키거나 불이익을 주는 행위를 한 경우<br/>
              8) 기타 기관이 정한 이용조건에 위반한 경우<br/><br/> <br/><br/>

              제 5 장 &nbsp;&nbsp;&nbsp;손해배상 등<br/><br/> <br/>

              제 18 조 (손해배상)<br/>
              기관은 서비스 요금이 무료인  서비스 이용과 관련하여 회원에게 발생한 어떠한 손해에 관하여도 책임을 지지 않습니다. 서비스 유료화 이후에 관하여는 별도로 정합니다.<br/> <br/><br/>

              제 19 조 (면책조항)<br/>
              ① 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 관한 책임이 면제됩니다.<br/>
              ② 회원의 귀책사유로 인한 서비스 이용의 장애에 대하여 책임을 지지 않습니다.<br/>
              ③ 회원이 서비스를 이용하여 기대하는 손익이나 서비스를 통하여 얻은 자료로 인한 손해에 관하여 책임을 지지 않습니다.<br/>
              ④ 회원이 서비스에 게재한 정보, 자료, 사실의 신뢰도, 정확성 등 내용에 관하여는 책임을 지지 않습니다.<br/> <br/><br/>

              제 20조 (관할법원)<br/>
              요금 등 서비스 이용으로 발생한 분쟁에 대해 소송이 제기될 경우 회사의 본사 소재지를 관할하는 법원을 관할법원으로 합니다.<br/><br/><br/>

              [부칙]<br/><br/>
              이 약관은 2004년 4월 1일부터 시행합니다.<br/>
              이 약관은 이 약관이 제정되기 전에 가입한 회원에게도 적용됩니다.

              <!--              <KSATextButton-->
              <!--                  text="[별첨] - 개인정보 처리방침 작성지침(2025.4.).pdf"-->
              <!--                  @click="$download('/platformfile/public/policy/202504.pdf')"-->
              <!--              />-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<style lang="scss" scoped>
.lecture-wrap {
  .content-title {
    font-weight: normal;
    .select {
      min-width: 166px;
      width: fit-content;
    }
  }
  .lecture-list {
    &:first-of-type {
      margin-bottom: 40px;
    }
  }
}
</style>
